import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const QRCallToActionWeb = props => {
  const { callToAction, qrUrl, qrImage } = props;

  if (!qrUrl || !qrImage) {
    return <div style={{ height: 96 }} />;
  }

  return (
    <div className={'flex flex-col sm:flex-row'}>
      <div className={'mx-auto sm:mx-0'}>
        <EFlyerWebQRCode qrImage={qrImage} />
      </div>
      <div
        className={
          'sm:ml-4 p-4 flex flex-col justify-center text-center sm:text-left min-w-0'
        }
      >
        <div className={'font-bold text-xl'}>{callToAction}</div>
        <div className={'text-xl pt-1 pr-4'}>{formatUrl(qrUrl)}</div>
      </div>
    </div>
  );
};

const EFlyerWebQRCode = ({ qrImage, className, ...props }) => {
  return (
    <div className={classNames('qr-code-container', className)} {...props}>
      <img src={qrImage} alt="QR Code" className="qr-code-image" />
    </div>
  );
};

const formatUrl = url => {
  if (!url) return url;

  // Replace standard hyphens with non-breaking hyphens
  const noBreakUrl = url.replace(/-/g, '\u2011');
  const result = [];
  let remaining = noBreakUrl;

  // calculate line breaks manually to improve readability
  while (remaining.length > 30) {
    const chunk = remaining.substring(0, 30);
    const lastSlash = chunk.lastIndexOf('/');
    const lastDot = chunk.lastIndexOf('.');
    const splitIndex = Math.max(lastSlash, lastDot);

    if (splitIndex !== -1) {
      result.push(remaining.substring(0, splitIndex + 1));
      remaining = remaining.substring(splitIndex + 1);
    } else {
      result.push(remaining.substring(0, 30));
      remaining = remaining.substring(30);
    }
  }

  if (remaining.length > 0) {
    result.push(remaining);
  }

  return result.map((part, index) => (
    <React.Fragment key={index}>
      {part}
      {index < result.length - 1 && <wbr />}
    </React.Fragment>
  ));
};

EFlyerWebQRCode.propTypes = {
  /** Data URL of the QR code image */
  qrImage: PropTypes.string.isRequired,
  /** Additional class names */
  className: PropTypes.string
};

export { QRCallToActionWeb };
